import * as era from '!/era'
import { ui } from '!/skin'
import type { JSX } from 'react'

// skin
const skin = era.skin('shared/ui/components/Skeleton')

type SkeletonType =
  | 'main'
  | 'grid'
  | 'category'
  | 'bundle'
  | 'epg'
  | 'catchups'
  | 'catchupsGridWithPrograms'
  | 'categoriesTabs'

const skeletonNamesByPageTypes: Record<SkeletonType, string> = {
  main: 'skeleton',
  grid: 'skeletonGrid',
  category: 'skeletonCategory',
  bundle: 'skeletonBundle',
  epg: 'skeletonEpg',
  catchups: 'skeletonCatchups',
  catchupsGridWithPrograms: 'catchupsGridWithPrograms',
  categoriesTabs: 'skeletonCategoriesTabs',
} as const

type SkeletonProps = {
  pageType: SkeletonType
  children: React.ReactNode
  isLoading?: boolean
}

Skeleton.displayName = 'Skeleton'
export function Skeleton({
  pageType,
  children,
  isLoading,
}: SkeletonProps): JSX.Element | null {
  const skeletonName = skeletonNamesByPageTypes[pageType]

  const isSkeletonShown = skeletonName && isLoading

  // TODO: render children under the skeleton
  if (isSkeletonShown)
    return <ui.RenderSkin from={skin} name={skeletonName} key={skeletonName} />

  return <>{children}</>
}
